import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class FortressSunken3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FORTRESS_SUNKEN3;
}

export default FortressSunken3PoiTileEntity;
